/**
 * CK mobile menu drawer: [data-ck-open-freshworks-chat] closes #CkMenuDrawer,
 * then finds the web chat launcher and emulates a click.
 * Freshchat-style launcher often uses .fc-widget-normal.fc-mobile-view; when open it
 * also gets .fc-open, .h-open-container (prefer clicking while closed via :not(.fc-open)).
 * Legacy Ember: .content-vp.ios-device.ember-view. Widget DOM may be in shadow roots or
 * same-origin iframes only.
 */
(function () {
  if (window.__ckMenuDrawerChatInit) return;
  window.__ckMenuDrawerChatInit = true;

  /** Try in order; first match wins. */
  var LAUNCHER_SELECTORS = [
    /* Freshworks iframe IDs (common + easy to click). */
    '#fc_frame',
    'iframe#fc_frame',
    '#fc_widget',
    'iframe#fc_widget',
    /* Freshworks "webchat" legacy Ember app container (some setups mount the click handler here). */
    '.ember-application',
    '[id*="webchat"].ember-application',
    '[id*="webchat"] .ember-application',
    '[id*="webchat"]',
    '.fc-widget-normal.fc-mobile-view:not(.fc-open)',
    '.fc-widget-normal:not(.fc-open)',
    '.fc-widget-normal.fc-mobile-view',
    '.fc-widget-normal',
    '.content-vp.ios-device.ember-view',
    '.content-vp.ember-view',
    '.ember-view.content-vp',
    '[class*="content-vp"][class*="ember-view"]',
    '#fc_widgets',
  ];

  var IFRAME_SRC_HINT = /fresh|fw-cdn|freshworks|freshchat|freshdesk|fwcrm/i;
  var RETRY_MS = 50;
  var RETRY_MAX = 30;

  function querySelectorDeep(root, selector) {
    if (!root || typeof root.querySelector !== 'function') return null;
    try {
      var hit = root.querySelector(selector);
      if (hit) return hit;
    } catch (e) {
      return null;
    }
    var nodes;
    try {
      nodes = root.querySelectorAll('*');
    } catch (e2) {
      return null;
    }
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n && n.shadowRoot) {
        var inner = querySelectorDeep(n.shadowRoot, selector);
        if (inner) return inner;
      }
    }
    return null;
  }

  function querySelectorInLikelyWidgetIframes(selector) {
    var iframes = document.querySelectorAll('iframe');
    for (var i = 0; i < iframes.length; i++) {
      var fr = iframes[i];
      var src = (fr.getAttribute('src') || '') + ' ' + (fr.getAttribute('id') || '') + ' ' + (fr.getAttribute('name') || '');
      if (!IFRAME_SRC_HINT.test(src)) continue;
      try {
        var doc = fr.contentDocument;
        if (!doc) continue;
        var root = doc.documentElement || doc.body;
        var el = querySelectorDeep(root, selector);
        if (el) return el;
      } catch (e) {
        /* cross-origin */
      }
    }
    return null;
  }

  function findLauncherClickTarget() {
    for (var s = 0; s < LAUNCHER_SELECTORS.length; s++) {
      var sel = LAUNCHER_SELECTORS[s];
      var el = querySelectorDeep(document.documentElement, sel);
      if (el) return el;
      el = querySelectorInLikelyWidgetIframes(sel);
      if (el) return el;
    }
    return null;
  }

  function clickLauncherElement(el) {
    if (!el) return;
    try {
      if (typeof el.click === 'function') {
        el.click();
        return;
      }
    } catch (e) {
      /* fall through */
    }
    try {
      el.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );
    } catch (e2) {
      /* ignore */
    }
  }

  function tryClickFreshworksLauncher(attempt) {
    attempt = attempt || 0;
    var el = findLauncherClickTarget();
    if (el) {
      /*
       * NOTE: If `el` is an <iframe>, clicking the iframe element itself won't open
       * the chat UI inside (and the frame is often cross-origin). Still click it
       * (harmless), but rely on API fallbacks below to actually open the widget.
       */
      clickLauncherElement(el);
    }
    if (attempt < RETRY_MAX) {
      setTimeout(function () {
        tryClickFreshworksLauncher(attempt + 1);
      }, RETRY_MS);
      return;
    }
    // Final fallback: call known widget APIs (preferred when DOM is in iframes/shadow roots).
    tryOpenFreshworksViaApi();
  }

  function tryOpenFreshworksViaApi() {
    var attempted = false;
    try {
      if (typeof FreshworksWidget === 'function') {
        attempted = true;
        FreshworksWidget('open');
      }
    } catch (e) {
      /* ignore */
    }
    try {
      if (window.fcWidget && typeof window.fcWidget.open === 'function') {
        attempted = true;
        window.fcWidget.open();
      }
    } catch (e2) {
      /* ignore */
    }
    try {
      if (window.fcWidget && typeof window.fcWidget.show === 'function') {
        attempted = true;
        window.fcWidget.show();
      }
    } catch (e3) {
      /* ignore */
    }
    return attempted;
  }

  function openFreshworksChat() {
    // API-first: when available, this is instant and avoids DOM polling delays.
    var apiAttempted = tryOpenFreshworksViaApi();
    if (apiAttempted) {
      // Still try a single DOM click on the next frame as a compatibility nudge.
      afterDrawerClosed(function () {
        var el = findLauncherClickTarget();
        if (el) clickLauncherElement(el);
      });
      return;
    }
    // Otherwise, poll for the launcher to appear.
    tryClickFreshworksLauncher(0);
  }

  function afterDrawerClosed(run) {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(run);
    } else {
      setTimeout(run, 0);
    }
  }

  function closeCkDrawerThen(run) {
    /* CK | The contact card of the search drawer uses the same trigger: close the search drawer too */
    var searchDrawer = document.getElementById('SearchDrawer');
    if (searchDrawer && searchDrawer.hasAttribute('open') && typeof searchDrawer.hide === 'function') {
      searchDrawer.hide();
    }

    var drawer = document.getElementById('CkMenuDrawer');
    if (!drawer || typeof drawer.hide !== 'function') {
      afterDrawerClosed(run);
      return;
    }

    var result = drawer.hide();
    if (result && typeof result.then === 'function') {
      result
        .then(function () {
          afterDrawerClosed(run);
        })
        .catch(function () {
          afterDrawerClosed(run);
        });
    } else {
      afterDrawerClosed(run);
    }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-ck-open-freshworks-chat]');
    if (!trigger) return;

    e.preventDefault();

    closeCkDrawerThen(openFreshworksChat);
  });
})();
